import React, { useState } from "react";
import { Link } from "react-router-dom";

const KilDashboardCategorieList = () => {
  const [selectedDisplay, setSelectedDisplay] = useState("10");

  const categories = [
    {
      id: 1,
      name: "Electronique",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      productCount: 64,
      stock: 134,
      createdAt: "14 Jan 2024",
      time: "10:00"
    },
    {
      id: 2,
      name: "Vêtement",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      productCount: 32,
      stock: 29,
      createdAt: "14 Jan 2024",
      time: "10:00"
    },
    {
      id: 3,
      name: "Telephones et Tablettes",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      productCount: 24,
      stock: 240,
      createdAt: "14 Jan 2024",
      time: "10:00"
    },
    {
      id: 4,
      name: "informatique",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      productCount: 48,
      stock: 0,
      createdAt: "14 Jan 2024",
      time: "10:00"
    },
    {
      id: 5,
      name: "Gaming et jeux videos",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      productCount: 44,
      stock: 56,
      createdAt: "14 Jan 2024",
      time: "10:00"
    }
  ];

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      {/* Header Section */}
      <div className="flex justify-between items-start mb-8">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Catégories de produits
            <div className="w-16 h-0.5 bg-orange-500 mt-2"></div>
          </h1>
          <div className="text-sm text-gray-600">
            <Link to="/dashboard" className="text-orange-500 hover:text-orange-600">
              Tableau de bord
            </Link>
            <span className="mx-2">{'>'}</span>
            <span>Catégories de produits</span>
          </div>
        </div>
        
        {/* Add Category Button */}
        <button className="flex items-center gap-2 px-4 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600">
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
          Ajouter une catégorie
        </button>
      </div>

      {/* Search and Filter Bar */}
      <div className="flex items-center gap-4 mb-6">
        {/* Search Bar */}
        <div className="relative flex-1 max-w-md">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </div>
          <input
            type="text"
            placeholder="Recherche..."
            className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
          />
        </div>

        {/* Filter Button */}
        <button className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg bg-white hover:bg-gray-50">
          <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
          </svg>
          <span className="text-gray-700">Filtre</span>
        </button>

        {/* Display Options */}
        <div className="flex items-center gap-2">
          <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
          </svg>
          <span className="text-gray-700">Affichage</span>
          <select
            value={selectedDisplay}
            onChange={(e) => setSelectedDisplay(e.target.value)}
            className="px-3 py-2 border border-gray-300 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
          >
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </div>
      </div>

      {/* Categories Table */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50 border-b border-gray-200">
              <tr>
                <th className="px-6 py-4 text-left">
                  <div className="flex items-center">
                    <input type="checkbox" className="rounded border-gray-300 text-orange-500 focus:ring-orange-500" />
                    <span className="ml-3 text-sm font-medium text-gray-900">NOM DE LA CATÉGORIE</span>
                  </div>
                </th>
                <th className="px-6 py-4 text-left text-sm font-medium text-gray-900">NBRE PRODUIT</th>
                <th className="px-6 py-4 text-left text-sm font-medium text-gray-900">STOCK</th>
                <th className="px-6 py-4 text-left text-sm font-medium text-gray-900">DATE DE CRÉATION</th>
                <th className="px-6 py-4 text-left text-sm font-medium text-gray-900">ACTION</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {categories.map((category) => (
                <tr key={category.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4">
                    <div className="flex items-center">
                      <input type="checkbox" className="rounded border-gray-300 text-orange-500 focus:ring-orange-500" />
                      <div className="ml-3">
                        <div className="text-sm font-medium text-gray-900">{category.name}</div>
                        <div className="text-sm text-gray-500">{category.description}</div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="text-sm text-gray-900">{category.productCount}</div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="text-sm text-gray-900">{category.stock}</div>
                  </td>
                  <td className="px-6 py-4">
                    <div>
                      <div className="text-sm text-gray-900">{category.createdAt}</div>
                      <div className="text-sm text-gray-500">{category.time}</div>
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex items-center space-x-4">
                      {/* View Button */}
                      <Link to={`/dashboard/categories/${category.id}`} className="text-gray-400 hover:text-blue-600">
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                        </svg>
                      </Link>
                      
                      {/* Edit Button */}
                      <button className="text-gray-400 hover:text-green-600">
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                        </svg>
                      </button>
                      
                      {/* Delete Button */}
                      <button className="text-gray-400 hover:text-red-600">
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                        </svg>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="bg-white px-6 py-4 border-t border-gray-200 flex items-center justify-between">
          <div className="text-sm text-gray-700">
            Affichage 1-5 sur 5
          </div>
          <div className="flex items-center space-x-2">
            <button className="px-3 py-1 text-gray-500 hover:text-gray-700">◀</button>
            <button className="px-3 py-1 text-white bg-orange-500 rounded-lg">1</button>
            <button className="px-3 py-1 text-gray-500 hover:text-gray-700">▶</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KilDashboardCategorieList;
